import React from 'react';

const PrivacyPolicyContent = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Política de Privacidade – Justiçai</h2>
      
      <p className="text-sm text-muted-foreground">
        Última atualização: 02 de setembro de 2025
      </p>
      
      <p>
        A Octopus Group – CNPJ 34.997.786/0001-85 ("Octopus Group", "nós"), empresa responsável pelo desenvolvimento e 
        operação da tecnologia Laib e da plataforma Justiçai ("Plataforma"), está comprometida em proteger a privacidade 
        e os dados pessoais de seus usuários.
      </p>
      
      <p>
        Esta Política de Privacidade explica de forma clara e transparente como coletamos, utilizamos, armazenamos, 
        compartilhamos e protegemos suas informações, em conformidade com a LGPD (Lei nº 13.709/2018) e demais legislações aplicáveis.
      </p>
      
      <section>
        <h3 className="text-md font-medium mb-2">1. Informações Coletadas</h3>
        
        <h4 className="font-medium mt-3">1.1. Fornecidas pelo usuário</h4>
        <p className="mt-1">• Dados de registro: nome, e-mail, número de inscrição profissional (como OAB), quando aplicável;</p>
        <p className="mt-1">• Conteúdo das consultas: perguntas, documentos e informações submetidas à Plataforma;</p>
        <p className="mt-1">• Dados de pagamento: processados por intermediários terceirizados confiáveis, não sendo armazenados diretamente pela Octopus Group;</p>
        <p className="mt-1">• Comunicações: informações fornecidas ao entrar em contato conosco para suporte ou outros fins.</p>
        
        <h4 className="font-medium mt-3">1.2. Coletadas automaticamente</h4>
        <p className="mt-1">• Dados de uso: interações com a Plataforma, funções acessadas, tempo e frequência de uso;</p>
        <p className="mt-1">• Informações do dispositivo: tipo, sistema operacional, navegador, endereço IP;</p>
        <p className="mt-1">• Cookies e tecnologias semelhantes: para melhorar a experiência do usuário e a segurança da Plataforma.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">2. Finalidades do Tratamento</h3>
        <p>As informações são utilizadas para:</p>
        <p className="mt-1">• Disponibilizar e aprimorar os serviços de IA jurídica;</p>
        <p className="mt-1">• Processar consultas e gerar respostas relevantes;</p>
        <p className="mt-1">• Autenticar usuários e proteger contas contra acessos indevidos;</p>
        <p className="mt-1">• Personalizar a experiência do usuário;</p>
        <p className="mt-1">• Processar assinaturas e transações;</p>
        <p className="mt-1">• Enviar comunicações sobre serviços, atualizações e suporte;</p>
        <p className="mt-1">• Treinar e melhorar os modelos de IA (Laib e IAs parceiras, como Google, OpenAI, Claude, Grok, Deepseek e Perplexity);</p>
        <p className="mt-1">• Cumprir obrigações legais e regulatórias;</p>
        <p className="mt-1">• Realizar análises estatísticas e de segurança da Plataforma.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">3. Compartilhamento de Informações</h3>
        <p>
          A Octopus Group não comercializa dados pessoais. O compartilhamento poderá ocorrer apenas quando:
        </p>
        <p className="mt-1">• Necessário para o funcionamento da Plataforma (ex.: processadores de pagamento, serviços de hospedagem e análise);</p>
        <p className="mt-1">• Exigido por lei, ordem judicial ou autoridade competente;</p>
        <p className="mt-1">• Para proteger direitos, privacidade, segurança ou propriedade da Octopus Group, de seus usuários ou do público;</p>
        <p className="mt-1">• Em operações societárias (fusão, aquisição, venda de ativos), sempre com aviso prévio.</p>
        <p className="mt-2">
          Todos os terceiros parceiros são contratualmente obrigados a manter a confidencialidade e segurança dos dados.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">4. Segurança das Informações</h3>
        <p>
          Adotamos medidas técnicas e organizacionais de alto nível para proteger suas informações, incluindo:
        </p>
        <p className="mt-1">• Criptografia de dados em trânsito e em repouso;</p>
        <p className="mt-1">• Controles rígidos de acesso a sistemas internos;</p>
        <p className="mt-1">• Monitoramento contínuo e prevenção de incidentes;</p>
        <p className="mt-1">• Treinamento periódico de segurança para a equipe;</p>
        <p className="mt-1">• Auditorias regulares de conformidade.</p>
        <p className="mt-2">
          Apesar das medidas adotadas, nenhum sistema é totalmente imune. O usuário também deve adotar práticas seguras de acesso.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">5. Retenção de Dados</h3>
        <p>
          Mantemos informações pessoais apenas pelo período necessário ao cumprimento das finalidades descritas nesta 
          Política e em conformidade com a lei.
        </p>
        <p className="mt-2">
          O tempo de retenção de consultas pode variar conforme o plano de assinatura contratado.
        </p>
        <p className="mt-2">
          O usuário pode solicitar a exclusão de seus dados, respeitadas obrigações legais e regulatórias de retenção.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">6. Direitos do Usuário (LGPD)</h3>
        <p>Em conformidade com a LGPD, o usuário possui os seguintes direitos:</p>
        <p className="mt-1">• Acesso aos dados tratados;</p>
        <p className="mt-1">• Correção de dados incompletos, inexatos ou desatualizados;</p>
        <p className="mt-1">• Exclusão de dados desnecessários, excessivos ou tratados em desconformidade;</p>
        <p className="mt-1">• Portabilidade dos dados a outro fornecedor de serviço;</p>
        <p className="mt-1">• Anonimização, bloqueio ou eliminação de dados tratados em excesso;</p>
        <p className="mt-1">• Revogação do consentimento, a qualquer momento;</p>
        <p className="mt-1">• Informação sobre compartilhamento de dados e sobre a possibilidade de não fornecer consentimento.</p>
        <p className="mt-2">
          Para exercer tais direitos, o usuário deve entrar em contato pelos canais indicados na Seção 10.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">7. Cookies e Tecnologias Semelhantes</h3>
        <p>Utilizamos cookies para:</p>
        <p className="mt-1">• Melhorar a experiência de navegação;</p>
        <p className="mt-1">• Analisar tendências e métricas de uso;</p>
        <p className="mt-1">• Aumentar a segurança da Plataforma.</p>
        <p className="mt-2">
          O usuário pode gerenciar cookies em seu navegador. A desativação poderá comprometer funcionalidades.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">8. Transferência Internacional de Dados</h3>
        <p>
          Alguns dados poderão ser processados em servidores fora do Brasil, inclusive em países com legislação diversa 
          sobre proteção de dados.
        </p>
        <p className="mt-2">
          Nestes casos, adotamos cláusulas contratuais padrão e outras salvaguardas adequadas para garantir nível de 
          proteção equivalente ao exigido pela LGPD.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">9. Alterações desta Política</h3>
        <p>
          A Octopus Group poderá atualizar esta Política periodicamente. Alterações relevantes serão comunicadas por meio 
          da Plataforma e, quando necessário, por e-mail.
        </p>
        <p className="mt-2">
          A versão mais recente estará sempre disponível em nosso site.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">10. Contato</h3>
        <p>
          Para dúvidas, solicitações ou exercício de direitos, entre em contato com nosso Encarregado de Proteção de Dados (DPO):
        </p>
        <p className="mt-2">
          📧 E-mail: privacidade@laib.com.br<br />
          📍 Endereço: São Leopoldo – RS, Brasil<br />
          📞 Telefone: (51) 99181-2486
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyContent;